
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt.json") })
        }
      }, "path---projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt!./.cache/json/projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt!./.cache/json/projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt.json
// module chunks = 15178676390636814000